import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import Navbar from '../components/layout/Navbar';

import HeroSection from '../components/landing/HeroSection';
import WhatIsSection from '../components/landing/WhatIsSection';
import FeaturesSection from '../components/landing/FeaturesSection';
import ResultsSection from '../components/landing/ResultsSection';
import CTASection from '../components/landing/CTASection';
import PricingSection from '../components/landing/PricingSection';

import { trackEvent } from '../utils/analytics';

export default function LandingPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    // When the LandingPage component mounts, track a custom event 
    trackEvent('LandingPage_Viewed');

    // Check if we need to scroll to a section
    if (location.state?.scrollTo) {
      const targetId = location.state.scrollTo;
      const element = document.getElementById(targetId);
      if (element) {
        const navbarHeight = 64;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  }, [location.state]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box>
      <Navbar />
      <HeroSection id="heroSection" />
      <WhatIsSection id="whatIsDivscore" />
      <FeaturesSection id="featuresSection" />
      <ResultsSection id="resultsSection" />
      <PricingSection id="pricingSection" />
      <CTASection id="ctaSection" />
    </Box>
  );
}